const apiKey = "xceV2Ucd72Kv3KaCp53kD_NgEaQk6YBW2fAkSUtnoP2Pac4RVh2wP3f3zH93ju4N3W2ISHqpI3utj12-F_Mjre0rJ4G8fbjaiwL-h4RyUIy4F64v0aLkK899FkmXYnYx" 


 const Yelp = {
   async searchYelp(term, location, sortBy) {
        return fetch(`https://cors-anywhere.herokuapp.com/https://api.yelp.com/v3/businesses/search?term=${term}&location=${location}&sort_by=${sortBy}
        `, {
            headers: {
                Authorization: `Bearer ${apiKey}`,
            }
        }).then(response => {
          return response.json()
        }).then(jsonResponse => {
            if (jsonResponse.businesses) {
                return jsonResponse.businesses.map((business) => {
                    return {
                        id: business.id,
                        imageSrc: business.image_url,
                        name: business.name,
                        address: business.location.address1,
                        city: business.location.city,
                        state: business.location.state,
                        zipCode: business.location.zip_code,
                        category: business.categories[0].title,
                        rating: business.rating,
                        reviewCount: business.review_count
                    }
                })
            }
        })
    }
}

export default Yelp